import { createI18n } from "@cleanbudget/i18n";
import { initReactI18next } from "react-i18next";

/** The admin's one i18next instance: Dutch, every namespace. Components use `useTranslation`. */
export const i18n = createI18n({ plugins: [initReactI18next] });
